import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client, { urlFor } from "../../sanity/sanityClient";

const ClickHandler = () => {
  window.scrollTo(10, 0);
};

const EventSection = (props) => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    client
      .fetch(
        `*[_type == "event"] | order(date asc) {
          title,
          slug,
          date,
          time,
          location,
          mainImage
        }`
      )
      .then((data) => {
        // Filter to only include future events
        const today = new Date();
        const upcomingEvents = data.filter(
          (event) => new Date(event.date) >= today
        );
        setEvents(upcomingEvents);
      })
      .catch(console.error);
  }, []);

  // Helper to adjust for local timezone and format
  const formatDate = (dateString) => {
    const date = new Date(dateString); // Parse the date from Sanity
    const localDate = new Date(
      date.getTime() + date.getTimezoneOffset() * 60000
    ); // Adjust to local timezone
    return localDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }); // Customize format as needed
  };

  return (
    <section className="wpo-event-section">
      <div className="container-fluid">
        <div className="event-wrap">
          <div className="row">
            <div className="col-lg-3 col-md-12 col-12">
              <div className="wpo-section-title">
                <span>Upcoming Campaign Events</span>
                <h2>Join us to shape the future of Erie County</h2>
              </div>
            </div>
            {events.length > 0 ? (
              events.map((event, index) => (
                <div className="col-lg-3 col-md-6 col-12" key={index}>
                  <div className="event-item">
                    <div className="image">
                      <img
                        src={urlFor(event.mainImage).width(400).url()}
                        alt={event.title}
                      />
                    </div>
                    <div className="event-content">
                      <span>
                        <i className="fa fa-map-marker" aria-hidden="true"></i>
                        {event.location}
                      </span>
                      <h2>
                        <Link
                          onClick={ClickHandler}
                          to={`/event-single/${event.slug.current}`}
                        >
                          {event.title}
                        </Link>
                      </h2>
                      <div className="event-date">
                        <span className="date">
                          <i className="fa fa-calendar" aria-hidden="true"></i>
                          {formatDate(event.date)}
                        </span>
                        <span className="time">
                          <i className="fa fa-clock-o" aria-hidden="true"></i>
                          {event.time}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12">
                <div className="no-events-message">
                  <h3>No upcoming events at this time.</h3>
                  <p>
                    Check back soon and follow us on social media for updates!
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventSection;
